import { ICurrency } from "store/fetchers/currencies"

export const getStoredCurrencyByCodeAndNetwork = (
    codeKey: string,
    networkKey: string,
    list: ICurrency[]
): ICurrency | null => {
    const code = sessionStorage.getItem(codeKey)
    const network = sessionStorage.getItem(networkKey)

    if (!code || !network) return null

    return list?.find(
        (c) =>
            c.code.toLowerCase() === code.toLowerCase() &&
            c.network.toLowerCase() === network.toLowerCase()
    )
}